(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["interstitial"] && !window.DesignMode) return;
  try {
    
	const form = document.querySelector('.section-interstitial__content');
	form.addEventListener('submit', function(e) {
		e.preventDefault();

		let userZip = document.querySelector('.section-interstitial__input').value;
		var isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(userZip);
		console.log(isValidZip)
		// console.debug('userZip', userZip);
		if (isValidZip) {
			let attArray = [];
			let isLocal = 'false';
			let orderType = ''
			if (window.zipArray.includes(userZip)) {
				isLocal = 'true';
				orderType = 'Local Delivery'
			}
		
			attArray.push({key: 'customer_zip_code', value: userZip});
			attArray.push({key: 'customer_is_local', value: isLocal});
			attArray.push({key: 'customer_order_type', value: orderType});
			window.MonScripts.updateCartAttributeArray(attArray);

		} else {
			document.querySelector('.invalid-zip-message').classList.remove('invalid-zip-message-hidden')
		}
		document.querySelector('.section-interstitial__input').addEventListener("keydown", () => {
				document.querySelector('.invalid-zip-message').classList.add('invalid-zip-message-hidden')
			});


	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-complementary-mon"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.js-comp-products');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
					WAU.Quickshop.init()
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.js-comp-products');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

})();
